import {styled} from "@mui/material";

export const NotificationsListHeader = styled('div')(() => {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        padding: '1rem 0.5rem 0 0.5rem',
    }
});

export const NotificationListContainer = styled('div')(({theme}) => {
    return {
        width: '100%',
        borderRadius: '0.5rem',
        border: `1px solid ${theme.barekam.additionalService.border.default}`,
        marginTop: '0.5rem',

        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',

        backgroundColor: '#fff',
        boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)',
    }
});

export const NotificationListItemContainer = styled('div')(() => {
    return {
        display: 'flex',
        width: '100%',
        cursor: 'pointer',
        borderBottom: '1px solid #CFCFE0',
        padding: '0.5rem',
    }
});

export const NotificationsListHeaderItem = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
    }
});

export const NotificationListItemStatus = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '2rem'
    }
});

export const NotificationListItemTitle = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingRight: '2rem'
    }
});

export const NotificationListItemBody = styled('div')(() => {
    return {
        width: '100%',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        paddingRight: '5rem'
    }
});
